import React, { useEffect, useState } from "react";

// 리더스북을 열었다고 첫 화면에 한 번 띄우는 알림(2026-10-18).
//
// 모든 학원에 띄운다(2026-10-18 대표). 문제지와 첨삭지 견본 두 장만 보여 주고 설명 줄은 넣지 않는다.
// 본 것은 이 기기에만 남긴다(localStorage). 기기를 바꾸면 한 번 더 뜰 뿐이다.
// 날짜가 지나면 아무에게도 안 뜬다.
//
// 다른 팝업과 겹치지 않게 `onResolved` 로 차례를 넘긴다(오류 수정 알림과 같은 방식).
const SEEN_KEY = "readersBookLaunchSeen";
const LAST_SHOWN_DATE = "2026-11-15";
const SAMPLE_LIST = [
  { label: "문제지", src: "/readers-book/worksheet.jpg" },
  { label: "첨삭지", src: "/readers-book/corrected.jpg" },
];

const isSeen = () => {
  try {
    return window.localStorage.getItem(SEEN_KEY) === "1";
  } catch {
    return false;
  }
};

const ReadersBookLaunchPopup = ({ onResolved }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const today = new Date().toLocaleDateString("sv-SE", { timeZone: "Asia/Seoul" });
    if (today <= LAST_SHOWN_DATE && !isSeen()) {
      setIsOpen(true);
    } else if (onResolved) {
      onResolved();
    }
  }, [onResolved]);

  if (!isOpen) return null;

  const close = () => {
    try {
      window.localStorage.setItem(SEEN_KEY, "1");
    } catch {
      // 저장이 막힌 브라우저는 다음에 한 번 더 뜬다
    }
    setIsOpen(false);
    if (onResolved) onResolved();
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(14,20,27,.55)",
        zIndex: 900,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "18px",
      }}
      onClick={close}
    >
      <div
        onClick={(event) => event.stopPropagation()}
        style={{
          background: "#fff",
          maxWidth: "640px",
          width: "100%",
          maxHeight: "calc(100vh - 36px)",
          overflowY: "auto",
          boxShadow: "0 30px 70px -30px rgba(10,30,35,.6)",
        }}
      >
        <div
          style={{
            background: "#0E141B",
            color: "#fff",
            padding: "20px 22px 18px",
            position: "relative",
          }}
        >
          <button
            type="button"
            aria-label="닫기"
            onClick={close}
            style={{
              position: "absolute",
              top: "12px",
              right: "12px",
              background: "none",
              border: "none",
              color: "#6d7d7b",
              fontSize: "18px",
              lineHeight: 1,
              cursor: "pointer",
              padding: "4px 6px",
            }}
          >
            ×
          </button>
          <div
            style={{
              fontSize: "11px",
              fontWeight: 800,
              letterSpacing: ".1em",
              color: "#00D9C0",
              marginBottom: "8px",
            }}
          >
            NEW
          </div>
          <div style={{ fontSize: "20px", fontWeight: 800, lineHeight: 1.4 }}>
            리더스북 오픈
          </div>
        </div>
        <div style={{ padding: "18px 22px 22px" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
            {SAMPLE_LIST.map((sample) => (
              <figure key={sample.label} style={{ margin: 0 }}>
                <img
                  src={sample.src}
                  alt={sample.label}
                  style={{ display: "block", width: "100%", border: "1px solid #E3E8EA" }}
                />
                <figcaption
                  style={{
                    marginTop: "6px",
                    fontSize: "13px",
                    fontWeight: 800,
                    color: "#3A434E",
                    textAlign: "center",
                  }}
                >
                  {sample.label}
                </figcaption>
              </figure>
            ))}
          </div>
          <button
            type="button"
            onClick={close}
            style={{
              display: "block",
              width: "100%",
              border: "none",
              cursor: "pointer",
              marginTop: "16px",
              background: "#00A396",
              color: "#fff",
              fontWeight: 800,
              fontSize: "15px",
              padding: "13px 0",
              textAlign: "center",
            }}
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReadersBookLaunchPopup;
